import { render } from "./ScannerGoogle.vue?vue&type=template&id=20ac086d"
import script from "./ScannerGoogle.vue?vue&type=script&lang=js"
export * from "./ScannerGoogle.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__